import axiosInstance from '@/app/api/axiosInstance';
import { NotificationListResponse, OTPNotification } from '@/app/types/notification';

export const getNotifications = async (
    limit: number = 50,
    offset: number = 0,
    status?: string,
    channel?: string
): Promise<NotificationListResponse> => {
    const params: Record<string, unknown> = { limit, offset };
    if (status) {
        params.status = status;
    }
    if (channel) {
        params.channel = channel;
    }

    const response = await axiosInstance.get<NotificationListResponse>('/notifications/', {
        params
    });
    return response.data;
};

export const getNotificationById = async (id: number): Promise<OTPNotification> => {
    const response = await axiosInstance.get<OTPNotification>(`/notifications/${id}`);
    return response.data;
};

export const markNotificationAsRead = async (id: number): Promise<OTPNotification> => {
    const response = await axiosInstance.post<OTPNotification>(`/notifications/${id}/read`);
    return response.data;
};
